import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store'  // 已删除，解决未使用错误

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login'),
        meta: {hidden: true}
    },
    {
        path: '/',
        name: 'CustomerSearch',
        component: () => import('@/views/CustomerSearch'),
        meta: {title: '查找客户'}
    },
    {
        path: '/customer-search',
        name: 'CustomerSearch',
        component: () => import('@/views/CustomerSearch'),
        meta: {title: '查找客户'}
    },
    {
        path: '/followUp',
        name: '/FollowUp',
        component: () => import('@/views/FollowUp'),
        meta: {title: '开发者信息'}
    },
    {
        path: '/work-order',
        name: 'WorkOrder',
        component: () => import('@/views/WorkOrder'),
        meta: {title: '工单管理'}
    },
    {
        path: '/code-plate',
        name: 'CodePlate',
        component: () => import('@/views/CodePlate.vue'),
        meta: {title: '转移记录'}
    },
    {
        path: '/users',
        name: 'UserManage',
        component: () => import('@/views/UserManage'),
        meta: {title: '用户管理'}
    },
    {
        path: '/roles',
        name: 'RoleManage',
        component: () => import('@/views/RoleManage'),
        meta: {title: '角色管理'}
    },
    {
        path: '/menus',
        name: 'Menus',
        component: () => import('@/views/Menu'),
        meta: {title: '菜单管理'}
    },
    {
        path: '/recharge',
        name: 'Recharge',
        component: () => import('@/views/Recharge'),
        meta: {title: '充值记录'}
    },
    {
        path: '/code-upgrade',
        name: 'CodeUpgrade',
        component: () => import('@/views/CodeUpgrade'),
        meta: {title: '设备升级记录'}
    },
    {
        path: '/recharge-transfer',
        name: 'RechargeTransfer',
        component: () => import('@/views/RechargeTransfer'),
        meta: {title: '转移记录'}
    },
    {
        path: '/device-blacklist',
        name: 'DeviceBlacklist',
        component: () => import('@/views/DeviceBlacklist.vue'),
        meta: {title: '黑名单记录'}
    },
    {
        path: '/device-records',
        name: 'DeviceRecords',
        component: () => import('@/views/DeviceRecords.vue'),
        meta: {title: '查询记录'}
    },
    {
        path: '/device-recharge',
        name: 'DeviceRecharge',
        component: () => import('@/views/DeviceRecharge.vue'),
        meta: {title: '充值记录'}
    },
    {
        path: '/device-print',
        name: 'DevicePrint',
        component: () => import('@/views/DevicePrint.vue'),
        meta: {title: '打印记录'}
    },
    {
        path: '/covenant',
        name: 'CovenantManage',
        component: () => import('@/views/CovenantManage.vue'),
        meta: {title: '承诺书管理'}
    },
    {
        path: '/platformStatistics',
        name: 'PlatformStatistics',
        component: () => import('@/views/PlatformStatistics.vue'),
        meta: {title: '平台统计'}
    },
    {
        path: '/freePrinter',
        name: 'FreePrinter',
        component: () => import('@/views/FreePrinter.vue'),
        meta: {title: '免费打印机'}
    },
    {
        path: '/pushOrder',
        name: 'PushOrder',
        component: () => import('@/views/PushOrder.vue'),
        meta: {title: '扫码推送统计'}
    },

    {
        path: '/mtShops',
        name: 'MtShops',
        component: () => import('@/views/shops/MtShops.vue'),
        meta: {title: '美团外卖'}
    },
    {
        path: '/mtSgShops',
        name: 'MtSgShops',
        component: () => import('@/views/shops/MtSgShops.vue'),
        meta: {title: '美团闪购'}
    },
    {
        path: '/elmShops',
        name: 'ElmShops',
        component: () => import('@/views/shops/ElmShops.vue'),
        meta: {title: '淘宝闪购·餐饮'}
    },
    {
        path: '/ebShops',
        name: 'EbShops',
        component: () => import('@/views/shops/EbShops.vue'),
        meta: {title: '淘宝闪购·零售'}
    },
    {
        path: '/jdShops',
        name: 'JdShops',
        component: () => import('@/views/shops/JdShops.vue'),
        meta: {title: '京东秒送'}
    },
    {
        path: '/dyShops',
        name: 'DyShops',
        component: () => import('@/views/shops/DyShops.vue'),
        meta: {title: '抖音来客'}
    },
    {
        path: '/mtTgShops',
        name: 'MtTgShops',
        component: () => import('@/views/shops/MtTgShops.vue'),
        meta: {title: '美团团购'}
    },
    {
        path: '/mtSyShops',
        name: 'MtSyShops',
        component: () => import('@/views/shops/MtSyShops.vue'),
        meta: {title: '美团试用'}
    },
    {
        path: '/kwaiShops',
        name: 'KwaiShops',
        component: () => import('@/views/shops/KwaiShops.vue'),
        meta: {title: '美团试用'}
    },
    {
        path: '/elmTgShops',
        name: 'ElmTgShops',
        component: () => import('@/views/shops/ElmTgShops.vue'),
        meta: {title: '淘宝闪购·团购'}
    },
    {
        path: '/kttShops',
        name: 'KttShops',
        component: () => import('@/views/shops/KttShops.vue'),
        meta: {title: '快团团'}
    },
    {
        path: '/wdShops',
        name: 'WdShops',
        component: () => import('@/views/shops/WdShops.vue'),
        meta: {title: '微店'}
    },
    {
        path: '/yzShops',
        name: 'YzShops',
        component: () => import('@/views/shops/YzShops.vue'),
        meta: {title: '有赞'}
    },
    {
        path: '/wmShops',
        name: 'WmShops',
        component: () => import('@/views/shops/WmShops.vue'),
        meta: {title: '微盟'}
    },
    {
        path: '/wm2Shops',
        name: 'Wm2Shops',
        component: () => import('@/views/shops/Wm2Shops.vue'),
        meta: {title: '微盟2'}
    },
    {
        path: '/tmSgShops',
        name: 'TmSgShops',
        component: () => import('@/views/shops/TmSgShops.vue'),
        meta: {title: '天猫闪购'}
    },

    {
        path: '/wdMdShops',
        name: 'WdMdShops',
        component: () => import('@/views/shops/WdMdShops.vue'),
        meta: {title: '微店面单'}
    },
    {
        path: '/yzMdShops',
        name: 'YzMdShops',
        component: () => import('@/views/shops/YzMdShops.vue'),
        meta: {title: '有赞面单'}
    },
    {
        path: '/wmMdShops',
        name: 'WmMdShops',
        component: () => import('@/views/shops/WmMdShops.vue'),
        meta: {title: '微盟面单'}
    },

    {
        path: '/supplier',
        name: 'Supplier',
        component: () => import('@/views/shops/Supplier.vue'),
        meta: {title: '点餐商户'}
    },

    {
        path: '/firmwareUpgrade',
        name: 'FirmwareUpgrade',
        component: () => import('@/views/FirmwareUpgrade.vue'),
        meta: {title: '固件升级'}
    },
    {
        path: '/live',
        name: 'Live',
        component: () => import('@/views/Live.vue'),
        meta: {title: '直播软件'}
    },
    {
        path: '/drive',
        name: 'Drive',
        component: () => import('@/views/Drive.vue'),
        meta: {title: '驱动软件'}
    },
    {
        path: '/barcode',
        name: 'Barcode',
        component: () => import('@/views/Barcode.vue'),
        meta: {title: '条码软件'}
    },
    {
        path: '/meal',
        name: 'Meal',
        component: () => import('@/views/Meal.vue'),
        meta: {title: '出餐宝软件'}
    },
    {
        path: '/orderAbnormal',
        name: 'OrderAbnormal',
        component: () => import('@/views/OrderAbnormal.vue'),
        meta: {title: '订单异常'}
    },
    {
        path: '/accountLog',
        name: 'AccountLog',
        component: () => import('@/views/AccountLog.vue'),
        meta: {title: '客服操作日志'}
    },
    {
        path: '/systemLog',
        name: 'SystemLog',
        component: () => import('@/views/SystemLog.vue'),
        meta: {title: '系统操作日志'}
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || '客服系统';
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
        if (to.path === '/login') {
            // 已登录且要去登录页，重定向到仪表盘
            next('/customer-search');
        } else {
            // 已登录且目标不是登录页，正常放行
            next();
        }
    } else {
        if (to.path === '/login') {
            // 未登录但去登录页，放行
            next();
        } else {
            // 未登录且目标不是登录页，重定向到登录页
            next('/login');
        }
    }
})

export default router